import {Text} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {LabelWithValueProps} from './interfaces'
import {classes} from './label-with-value.st.css'

export const LabelWithValue = ({label, labelClassName, valueClassName, value}: LabelWithValueProps) =>
  value ? (
    <div className={classes.labelWithValue}>
      <Text tagName="p" className={classNames(classes.smallText, labelClassName ?? classes.smallTextColor)}>
        {label}
      </Text>
      <Text tagName="p" className={classNames(classes.value, valueClassName ?? classes.valueColor)}>
        {value}
      </Text>
    </div>
  ) : null
